import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { topIcon } from '../../icons';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';

export const TopUnavailable = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('top3-service-denied-unavailable-reason-banner-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ErrorWrapper icon={topIcon}>Размещение Топ объявления недоступно</ErrorWrapper>;
};
